export default "__VITE_ASSET__CIVAiNUG__"